import React, { useState } from 'react';
import { Button, Dropdown, Menu, MenuProps } from 'antd';
import { Link } from 'react-router-dom';

import menuButtonUserIcon from 'assets/icons/menuButtonUserIcon.svg';
import menuButtonUserIconClose from 'assets/icons/menuButtonUserIconClose.svg';

import './userMenuButtonComponent.scss';

import { USER_MENU } from 'constants/enums/user-menu';
import { RoleGuardComponent } from 'baseComponents/RoleGuardComponent';
import { USER_ROLE } from 'constants/enums/user-roles';
import { useAuthStoreActions } from 'store/AuthStore';
import { useUserStoreActions } from 'store/UserStore';

export const UserMenuButtonComponent: React.FC = () => {
  const [menuClosed, closeMenu] = useState<boolean>(true);
  const [currentMenuItem, setCurrentMenuItem] = useState<string>('');
  const { logout } = useAuthStoreActions();
  const { clearUserDetail } = useUserStoreActions();

  const handleMenuItemClick: MenuProps['onClick'] = (e) => {
    setCurrentMenuItem(e.key);
  };

  return (
    <Dropdown
      overlayClassName='user-menu-dropdown'
      onOpenChange={() => closeMenu(!menuClosed)}
      open={!menuClosed}
      dropdownRender={() => (
        <Menu selectedKeys={[currentMenuItem]} onClick={handleMenuItemClick}>
          <RoleGuardComponent roles={[USER_ROLE.admin, USER_ROLE.developer]}>
            <Menu.Item>
              <Link to='/admin'>{USER_MENU.ADMIN_DASHBOARD}</Link>
            </Menu.Item>
          </RoleGuardComponent>
          <Menu.Item>
            <Link to='/help'>{USER_MENU.HELP}</Link>
          </Menu.Item>
          <RoleGuardComponent roles={[USER_ROLE.franchiseOwner]}>
            <Menu.Item key='purchase-credits'>
              <Link to='/purchase-credits'>{USER_MENU.PURCHASE_CREDITS}</Link>
            </Menu.Item>
          </RoleGuardComponent>
          <Menu.Item key='logout'>
            <Link
              to='/'
              onClick={() => {
                logout();
                clearUserDetail();
              }}
            >
              {USER_MENU.LOGOUT}
            </Link>
          </Menu.Item>
        </Menu>
      )}
    >
      <Button className='menu-button' onClick={() => closeMenu(!menuClosed)}>
        <img
          src={menuClosed ? menuButtonUserIcon : menuButtonUserIconClose}
          alt='User icon on menu button'
        />
      </Button>
    </Dropdown>
  );
};
